import type { ReactNode } from 'react';

/**
 * A table that may be wider than its card or modal scrolls sideways inside it, instead of pushing the page wider
 * (1.2.1). Long text columns wrap (`td.wrap`); status, size, date and button columns stay on one line.
 */
export function TableScroll({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={className ? `table-scroll ${className}` : 'table-scroll'}>{children}</div>;
}
